import React from 'react';

type alignTypes = "left" | "center" | "right"
function Pagination({align, pages, setPages, totalPages}:
                        {align: alignTypes, pages: number, setPages: Function, totalPages: number}) {
    const pageSize: number = 7;
    const totalPage: number = Math.round(totalPages / 10)

    let startPage: number = pages - Math.floor(pageSize / 2);
    let endPage: number = startPage+pageSize

    if(pages < Math.round(pageSize / 2)){
        startPage = 1
        endPage = pageSize + 1;
    }else if(pages + Math.floor(pageSize / 2) < totalPage){
        startPage = pages - Math.floor(pageSize / 2)
    }else{
        if(pages > totalPage - Math.floor(pageSize / 2)){
            startPage = totalPage - pageSize + 1
        }
        endPage = totalPage + 1
    }

    if(endPage > totalPage){
        endPage = totalPage
    }

    const pageList: number[] = []
    for(let i=startPage; i<=endPage; i++){
        pageList.push(i)
    }

    return (
        <div className={`pagination ${align}`}>
            <ul>
                {
                    pageList.map((list, index)=> {
                        const returnPage = list
                        return (
                            <li key={index}>
                                <a href="#"
                                   className={pages == list ? "on" : ""}
                                   onClick={e=> {
                                       setPages(returnPage)
                                   }}
                                >{returnPage}</a>
                            </li>
                        )
                    })
                }
            </ul>
        </div>
    );
}
Pagination.defaultProps = {
    align: "center",
    pageSize: 10,
}
export default Pagination;
